/*eslint-disable*/
import React from "react";
import FooterImage from "./FooterImage";
import FooterMenu from "./FooterMenu";
import FooterMain from "./FooterMain";
import { isAuthenticated } from "utils/common";

function Footer() {
  return (
    <footer className={`${isAuthenticated() ? "auth" : ""}`}>
      <FooterImage isAuth={isAuthenticated()} />
      <FooterMenu isAuth={isAuthenticated()} />
      <FooterMain />
    </footer>
  );
}

export default Footer;
